<template>
	<tr>
		<slot />
	</tr>
</template>
